import { FC, useEffect } from 'react';
import FileUploaderTile from '@views/AdminPage/ImportMedications/FileUploaderTile';
import FileUploader from '@views/AdminPage/ImportMedications/FileUploader/FileUploader';
import { EventType } from '@utils/eventBus';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import useDispatch from '@store/hooks/useDispatch';
import { handleAdminHighRiskSupplementsList } from '@store/features/adminImportMedications/actions';
import {
  adminImportHighRiskSupplementsListErrorsSelector,
  adminImportHighRiskSupplementsListLoadingSelector,
} from '@store/features/adminImportMedications/selectors';
import { removeAdminImportHighRiskSupplementsList } from '@store/features/adminImportMedications/slice';

const HighRiskSupplementsList: FC = (): JSX.Element => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const isLoadingHighRiskSupplementsList = useSelector(
    adminImportHighRiskSupplementsListLoadingSelector,
  );
  const errorsHighRiskSupplementsList = useSelector(
    adminImportHighRiskSupplementsListErrorsSelector,
  );
  const hasErrorsHighRiskSupplementsList = errorsHighRiskSupplementsList.length > 0;

  useEffect(() => {
    dispatch(removeAdminImportHighRiskSupplementsList());
  }, []);

  return (
    <FileUploaderTile title={t('admin.importHighRiskSupplementsListHeader')}>
      <FileUploader
        className="import-medications__file-uploader"
        importHandler={handleAdminHighRiskSupplementsList}
        errors={errorsHighRiskSupplementsList}
        eventType={EventType.ADMIN_IMPORT_HIGH_RISK_SUPPLEMENTS_LIST_SUCCESS}
        hasErrors={hasErrorsHighRiskSupplementsList}
        isLoading={isLoadingHighRiskSupplementsList}
        successMessage={t('admin.importHighRiskSupplementsSuccess')}
      />
    </FileUploaderTile>
  );
};

export default HighRiskSupplementsList;
